import React, { useContext } from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FuelButton, FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import AppContext from '@context';
import useLoadJourneys from '@hooks/useLoadJourneys';
import useLoadProposals from '@hooks/useLoadProposals';
import useCheckUpdates from '@hooks/useCheckUpdates';
import useAmplitude from '@hooks/useAmplitude';
import * as Styled from './CheckUpdateStyles';

function CheckUpdate() {
  const { dispatch } = useContext(AppContext);
  const { amplitudeEvent } = useAmplitude();
  const { fetchJourneys } = useLoadJourneys('lazy');
  const { fetchProposals } = useLoadProposals();
  const { hasUpdateAvailable } = useCheckUpdates();

  function handleReload() {
    dispatch({
      type: 'filters_status_update',
      payload: { status: [] },
    });
    fetchProposals({ page: 1 });
    fetchJourneys({ page: 1 });
    amplitudeEvent('journey_check_update_click_button_reload_list');
  }

  if (!hasUpdateAvailable) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <FuelFlex
        defaultProps={{
          backgroundColor: dsTokens.color.background.neutral.weak,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'km2',
          gap: 'km1',
        }}
      >
        <FuelIcon name="reload" color="red" size="tiny" />
        <FuelTypography size="caption" weight="medium" color="neutral-strong">
          Você tem novas atualizações em suas viagens.
        </FuelTypography>
        <FuelButton variant="secondary" onClick={() => handleReload()}>
          Atualizar
        </FuelButton>
      </FuelFlex>
    </Styled.Wrapper>
  );
}

export default CheckUpdate;
